import { render, staticRenderFns } from "./StaticPages.vue?vue&type=template&id=83b1f7a0"
import script from "./StaticPages.vue?vue&type=script&lang=js"
export * from "./StaticPages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports